import { DeleteOutline } from '@mui/icons-material'
import * as S from './InvoivesTable.styles'

interface InvoicesTableParams {
  invoiceList: string[]
  headerText: string
  removeAction?: (index: number) => any
  removeDisabled?: boolean
}

export const InvoicesTable: React.FC<InvoicesTableParams> = ({
  invoiceList,
  headerText,
  removeAction,
  removeDisabled = false,
}) => (
  <S.Table>
    <S.THead>
      <S.Tr>
        <S.Th>{headerText}</S.Th>
        {removeAction && <S.Th>Remover</S.Th>}
      </S.Tr>
    </S.THead>
    <S.TBody>
      {invoiceList.map((invoice, index) => (
        <S.Tr key={index}>
          <S.Td>
            {invoice}
          </S.Td>
          {removeAction && (
            <S.Td>
              {removeDisabled ? (
                <DeleteOutline
                  sx={{ color: 'disabled', cursor: 'pointer' }}
                  data-testid='remove-invoice-key-button-test'
                />
              ) : (
                <DeleteOutline
                  sx={{ color: 'red', cursor: 'pointer' }}
                  onClick={() => removeAction(index)}
                  data-testid='remove-invoice-key-button-test'
                />
              )}
            </S.Td>
          )}
        </S.Tr>
      ))}
    </S.TBody>
  </S.Table>
)
